const sortPopup = {
  popup: document.getElementById('jsSortWrap') as HTMLElement | null,
  form: document.getElementById('sortForm') as HTMLFormElement | null,
  applyBtn: document.getElementById('jsApplySort') as HTMLButtonElement | null,


  init() {
    if (!this.popup) return;
    this.setApply();
  },

  setApply() {
    if (!this.applyBtn || !this.form) return;

    this.applyBtn.addEventListener('click', () => {
      this.form!.submit();
    });
  },

};

export default sortPopup;
